import { render, staticRenderFns } from "./umatDetail.vue?vue&type=template&id=d55d6b56&scoped=true&"
import script from "./umatDetail.vue?vue&type=script&lang=js&"
export * from "./umatDetail.vue?vue&type=script&lang=js&"
import style0 from "./umatDetail.vue?vue&type=style&index=0&id=d55d6b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55d6b56",
  null
  
)

export default component.exports